import { SIMPLE_SUM } from "./simple-sum";
import { AVERAGE_UNITS } from "./average-units";
import { STORE_WITH_UNITS } from "./store-with-units";
import { IMU_PERCENTAGE } from "./imu-percentage";
import { AUR } from "./aur";
import { UNIT_DOOR_PERCENTAGE_PLAN } from "./unit-door-percentage-plan";
import { DOOR_PERCENTAGE_PLAN } from "./door-percentage-plan";
import { AVERAGE_DEPTH } from "./average-depth";
import { AVERAGE_COST } from "./average-cost";

const totalsPlanRowFormula = {
    UNITS: SIMPLE_SUM,
    AVERAGE_UNITS: AVERAGE_UNITS,
    STORE_WITH_UNITS: STORE_WITH_UNITS,
    TOTAL_COST: SIMPLE_SUM,
    TOTAL_RETAIL: SIMPLE_SUM,
    PLAN_ROWS: SIMPLE_SUM,
    IMU_PERCENTAGE: IMU_PERCENTAGE,
    AUR: AUR,
    UNIT_ROW_PERCENTAGE_PLAN: () => 100,
    ROW_PERCENTAGE_PLAN: () => 100,
    UNIT_DOOR_PERCENTAGE_PLAN: UNIT_DOOR_PERCENTAGE_PLAN,
    DOOR_PERCENTAGE_PLAN: DOOR_PERCENTAGE_PLAN,
    BREADTH_PERCENTAGE_PLAN: () => 100,
    AVERAGE_DEPTH: AVERAGE_DEPTH,
    AVERAGE_COST: AVERAGE_COST,
};

export const getPlanRowValue = ({ factoryOptions, getterParams }) => {
    const { metric, doorId } = factoryOptions;

    let planValue;
    if (doorId) {
        planValue = SIMPLE_SUM({ factoryOptions, getterParams });
    } else {
        const formula = totalsPlanRowFormula[metric.kind];
        planValue = formula({ factoryOptions, getterParams });
    }
    return planValue;
};
